// TODO: nav title is hackishly - set this with some combo of react-redux and react-router

import React, {PropTypes} from 'react';
import { Link, IndexLink, browserHistory } from 'react-router';

import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

// ICONS
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DirectionsIcon from 'material-ui/svg-icons/maps/directions';
import SpannerIcon from 'material-ui/svg-icons/action/build';
import TextsmsIcon from 'material-ui/svg-icons/communication/textsms';
import QuestionAnswerIcon from 'material-ui/svg-icons/action/question-answer';
import LibraryIcon from 'material-ui/svg-icons/maps/local-library';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment';
import ContentLinkIcon from 'material-ui/svg-icons/content/link';
import HelpIcon from 'material-ui/svg-icons/action/help';
import ExitIcon from 'material-ui/svg-icons/action/exit-to-app';

import HelpPage from '../help/page';

class Nav extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      helpModalOpen: false,
      title: "Leadership Competencies"
    };
    this.toggleNav = this.toggleNav.bind(this);
    this.toggleHelpModal = this.toggleHelpModal.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
  }

  toggleNav(){
    this.setState({open: !this.state.open});
  }

  toggleHelpModal(){
    this.setState({helpModalOpen: !this.state.helpModalOpen});
  }

  navigateTo(navTarget, title){
    browserHistory.push(navTarget);
    this.setState({title: title});
    this.setState({open: false});
  }

  render() {
    const toggleNav = this.toggleNav;
    const toggleHelpModal = this.toggleHelpModal;
    const navigateTo = this.navigateTo;

    const actions = [
      <FlatButton
        key="1"
        label="Close"
        primary={true}
        onTouchTap={this.toggleHelpModal}
      />
    ];

    return (
      <div>
        <AppBar
            title={this.state.title}
            className="app-bar"
            iconElementRight={
              <IconMenu
                iconButtonElement={
                  <IconButton><MoreVertIcon /></IconButton>
                }
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
              >
                <MenuItem
                  primaryText="Help"
                  leftIcon={<HelpIcon />}
                  onTouchTap={toggleHelpModal}
                />
                <MenuItem primaryText="Sign out"
                  leftIcon={<ExitIcon />}
                />
              </IconMenu>
            }
            onLeftIconButtonTouchTap={toggleNav}
          />
          <Drawer open={this.state.open}
            width= {290}
            >
              <Menu>
                <MenuItem
                  primaryText="Leadership Competencies"
                  leftIcon={<DirectionsIcon />}
                  onTouchTap={() => navigateTo("/leadership-comps", "Leadership Competencies")}
                />
                <MenuItem
                  primaryText="Functional Skills"
                  leftIcon={<SpannerIcon />}
                  onTouchTap={() => navigateTo("/functional-skills", "Functional Skills")}
                />
                <MenuItem
                  primaryText="Course Resources"
                  leftIcon={<LibraryIcon />}
                  onTouchTap={() => navigateTo("/course-resources", "Course Resources")}
                />
                <MenuItem
                  primaryText="How To"
                  leftIcon={<AssignmentIcon />}
                  onTouchTap={() => navigateTo("/how-to", "How To")}
                />
                <MenuItem
                  primaryText="Contribute"
                  leftIcon={<QuestionAnswerIcon />}
                  onTouchTap={() => navigateTo("/contribute", "Contribute")}
                />
                <MenuItem
                  primaryText="Useful Sites"
                  leftIcon={<ContentLinkIcon />}
                  onTouchTap={() => navigateTo("/useful-sites", "Useful Sites")}
                />
                {/*
                <Divider />
                <MenuItem primaryText="Make a copy" leftIcon={<ContentCopy />} />
                <MenuItem primaryText="Download" leftIcon={<Download />} />
                <Divider />
                <MenuItem primaryText="Remove" leftIcon={<Delete />} />
                */}
              </Menu>
          </Drawer>

          <Dialog
            actions={actions}
            modal={true}
            open={this.state.helpModalOpen}
          >
            <HelpPage/>
          </Dialog>
      </div>
    );
  }
}

Nav.propTypes = {
  //loading: PropTypes.bool.isRequired
};

export default Nav;



/** WEBPACK FOOTER **
 ** ./src/components/common/Nav.js
 **/